import { IRevenueSpendCrudModalLang } from '../../../types/lang'

export const revenueSpendCrudModalLang: IRevenueSpendCrudModalLang = {
	revenue_spend_crud_modal: {
		title_create: 'Create revenue spend_ru',
		title_edit: 'Edit revenue spend_ru',
		title_remove_single: 'Remove <span>revenue spend_ru</span>',
		title_notes_view: 'View notes for revenue spend_ru',
		title_notes_edit: 'Edit notes for revenue spend_ru',
		title_history_view: 'View history in revenue spend_ru',
		title_select_users: 'Revenue spend select users (buyers) for revenue agency_ru',
		label_mode_revenue_cpa: 'Revenue Cpa_ru',
		label_mode_revenue_spend: 'Revenue Spend_ru',
		label_mode_revenue: 'Revenue_ru',
		title_by_account_revenue: 'View revenue spend - {{mode}} - detail info by account {{account}} - {{date}}_ru',
		title_by_account_revenue_total: 'View TOTAL revenue spend - {{mode}} - detail info_ru',
		title_by_account_offer_spend: 'View revenue spend - Revenue Offer Spend - detail info by account {{account}} - {{date}}_ru',
		title_by_account_offer_spend_total: 'View TOTAL revenue spend - Revenue Offer Spend - detail info_ru',
		title_by_account_spend: 'View revenue spend - Spend - detail info by account {{account}} - {{date}}_ru',
		title_by_account_spend_total: 'View TOTAL revenue spend - Spend - detail info_ru',
		title_by_team_revenue: 'View revenue spend - {{mode}} - detail info by team {{team}} - {{date}}_ru',
		title_by_team_revenue_total: 'View TOTAL revenue spend - {{mode}} - detail info_ru',
		title_by_team_offer_spend: 'View revenue spend - Revenue Offer Spend - detail info by team {{team}} - {{date}}_ru',
		title_by_team_offer_spend_total: 'View TOTAL revenue spend - Revenue Offer Spend - detail info_ru',
		title_by_team_spend: 'View revenue spend - Spend - detail info by team {{team}} - {{date}}_ru',
		title_by_team_spend_total: 'View TOTAL revenue spend - Spend - detail info_ru',
		field_agency_label: 'Agency_ru',
		field_agency_placeholder: 'Agency_ru',
		field_account_label: 'Account_ru',
		field_account_placeholder: 'Account_ru',
		field_kt_group_label: 'KT Group_ru',
		field_kt_group_placeholder: 'KT Group_ru',
		field_date_label: 'Date_ru',
		field_date_placeholder: 'Date_ru',
		field_amount_label: 'Amount_ru',
		field_amount_placeholder: 'Type number_ru',
		field_notes_label: 'Notes_ru',
		field_notes_placeholder: 'Notes_ru',
		msg_remove_confirm: 'Are you sure?_ru',
		btn_select_users: 'Select Users (Buyers)_ru',
		btn_create: 'Create_ru',
		btn_update: 'Save_ru',
		btn_remove: 'Remove_ru',
		btn_close: 'Close_ru'
	}
}